import script from "./PowerCount.vue?vue&type=script&setup=true&lang=js"
export * from "./PowerCount.vue?vue&type=script&setup=true&lang=js"

import "./PowerCount.vue?vue&type=style&index=0&id=1e067326&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e067326"]])

export default __exports__